
<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import * as R from 'ramda'
import { mapState } from 'vuex'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'

export default {
  name: 'ReportProjectList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'projectrecords',
        getParams: this.getParam,
      }),
      exportDataOptions: {
        items: [
          { label: this.$t('scope.text_869'), key: 'name' },
          { label: this.$t('scope.text_870'), key: 'enterprise_name' },
          { label: this.$t('scope.text_871'), key: 'amount' },
          { label: this.$t('scope.text_872'), key: 'address' },
          { label: this.$t('scope.text_873'), key: 'contact' },
          { label: this.$t('scope.text_874'), key: 'department' },
          { label: this.$t('scope.text_875'), key: 'position' },
          { label: this.$t('scope.text_876'), key: 'created_at' },
          { label: this.$t('scope.text_877'), key: 'status' },
          { label: this.$t('scope.text_878'), key: 'memo' },
        ],
      },
    }
  },
  computed: {
    ...mapState('app', {
      cities: state => state.cities,
    }),
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams) }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'ReportProjectSidePage', {
        id: row.id,
        resource: 'projectrecords',
      }, {
        list: this.list,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/less/theme';
  .status-success {
    color: @success-color;
  }
  .status-danger {
    color: @error-color;
  }
  .status-info {
    color: @normal-color;
  }
</style>
